export default __webpack_public_path__ + "static/media/monkey-6.d87565b3.png";